const normalize = (value = '') =>
  String(value)
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '') // quita acentos
    .toUpperCase()
    .replace(/[^A-Z0-9/ ]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()

const extractBankLabel = (accountName = '') => {
  // "BANOBRAS - 4571" -> "BANOBRAS"
  return normalize(accountName.split('-')[0])
}

export const getBankFromAccountName = (banks = [], accountName = '') => {
  const label = extractBankLabel(accountName)

  if (!label || !Array.isArray(banks) || banks.length === 0) return null

  // 1) exacto normalizado
  let match = banks.find((b) => normalize(b.bank) === label)
  if (match) return match

  // 2) fallback por inclusión (bidireccional)
  return (
    banks.find((b) => {
      const bankNorm = normalize(b.bank)
      return bankNorm.includes(label) || label.includes(bankNorm)
    }) || null
  )
}